/*@ngInject*/
const NotificationPopupTemplateRepository = function (baseRepository, baseCachedRepository) {

    angular.extend(this, baseRepository);
    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'notificationPopupTemplateRepository';
    };

    this.getCacheCapacity = function () {
        return 100;
    };

    this.loadActions = function (id) {
        var url = '/rest/Actions',
            cacheKey = 'notificationPopupTemplate-actions-' + id,
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.notification.NotificationPopupTemplate:' + id
                }
            };

        return this.get(cacheKey, url, config);
    };

    this.getNotificationPopupTemplate = function (id) {
        var url = '/rest/NotificationPopupTemplate/' + id,
            cacheKey = 'notificationPopupTemplate-' + id;
        return this.get(cacheKey, url);
    };

    this.saveNotificationPopupTemplate = function (notificationPopupTemplate) {
        var url = '/rest/NotificationPopupTemplate',
            body = notificationPopupTemplate,
            config = {
                params: {}
            },
            cacheKey = 'notificationPopupTemplate-' + notificationPopupTemplate.id;
        if (notificationPopupTemplate.id) {
            url = '/rest/NotificationPopupTemplate/' + notificationPopupTemplate.id;
            this.removeFromCache(cacheKey);
        }
        return this.post(url, body, config);
    };

    this.deleteNotificationPopupTemplate = function (id) {
        var url = '/rest/NotificationPopupTemplate/' + id;
        return this.delete(url);
    };

    this.processResponseData = function (responseData) {
        return responseData;
    };
};

angular.module('umCore')
    .service('notificationPopupTemplateRepository', NotificationPopupTemplateRepository);
